export const addRecordingEventFormField = [
	{
		type: 'url',
		title: 'Recording Link',
		placeholder: 'Add event recording',
		formControlName: 'recordingUrl',
		required: true,
		errorsMsg: [
			{ type: 'required', message: 'Url is required' },
			{ type: 'pattern', message: 'Enter valid url' },
		],
	},
	{
		type: 'text',
		title: 'User Id',
		placeholder: 'User Id',
		formControlName: 'userId',
		required: true,
		disabled: true,
		errorsMsg: [{ type: 'required', message: 'UserId is required' }],
	},
	{
		type: 'text',
		title: 'Post Id',
		placeholder: 'Post Id',
		formControlName: 'postId',
		required: true,
		disabled: true,
		errorsMsg: [{ type: 'required', message: 'PostId is required' }],
	},
];
